import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { VaultService } from '../../services/vault.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { GeneralService } from '../../services/general.service';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../../components/modal/modal.component';
import { InputComponent } from '../../utilities/input/input.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { PaginationComponent } from '../../utilities/pagination/pagination.component';
import { PermissionService } from '../../services/permissions.service';

@Component({
  selector: 'app-vault',
  standalone: true,
  imports: [
    DashboardComponent,
    ButtonComponent,
    CommonModule,
    ModalComponent,
    InputComponent,
    DropdownComponent,
    PaginationComponent,
  ],
  templateUrl: './vault.component.html',
  styleUrl: './vault.component.scss',
})
export class VaultComponent {
  fetchingData: boolean = false;
  tableHeader: any[] = [];
  tableData: any[] = [];
  filterData: any[] = [];
  vaultEnvironments: any = ['Development', 'Production'];
  limit: number = 10;
  deleteId: string = '';
  emptyState: boolean = false;
  page: number = 1;
  pages: number = 0;
  deleteModalOpen: boolean = false;
  fromDate: any;
  vaults: any;
  loading: boolean = false;
  totalVaults: number = 0;
  createModalOpen: boolean = false;
  toDate: any;
  showKey: boolean[] = [];
  emptyTableState = {
    title: 'No data found',
    label: 'You have no vaults',
  };
  newVault: any = {
    name: '',
    environment: '',
  };
  errors: any = {
    name: '',
    environment: '',
  };
  canWrite = false;
  canDelete = false;
  canUpdate = false;
  constructor(
    private generalService: GeneralService,
    private vaultService: VaultService,
    private notification: NzNotificationService,
    private permissionService: PermissionService
  ) {
    this.showKey = new Array(this.vaults?.length).fill(false);
    this.getVaults();
    this.fromDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.toDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.filterData = [
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'channel',
        label: 'Channel',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'wallet', value: 'Wallet' },
          { key: 'card', value: 'Card' },
          { key: 'ussd', value: 'Ussd' },
          { key: 'loyaltyCard', value: 'Loyalty Card' },
          { key: 'onlineTransfer', value: 'Online Transfer' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-type',
        label: 'Transaction Type',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'funding', value: 'Funding' },
          { key: 'withdrawal', value: 'Withdraw' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-status',
        label: 'Transaction Status',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'failed', value: 'Failed' },
          { key: 'success', value: 'Success' },
          { key: 'pending', value: 'Pending' },
        ],
      },
      {
        type: 'select',
        name: 'transaction-initiator',
        label: 'Transaction Initiator',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'company', value: 'Company' },
          { key: 'customer', value: 'Customer' },
        ],
      },
    ];
  }
  ngOnInit() {
    this.canWrite = this.permissionService.hasPermission('Write');
    this.canDelete = this.permissionService.hasPermission('Delete');
    this.canUpdate = this.permissionService.hasPermission('Update');
    console.log(this.canDelete, this.canWrite, this.canUpdate);
  }
  openCreateModal() {
    this.createModalOpen = true;
  }
  closeCreateModal() {
    this.createModalOpen = false;
  }
  openDeleteModal(id: string) {
    this.deleteModalOpen = true;
    this.deleteId = id;
  }
  closeDeleteModal() {
    this.deleteModalOpen = false;
  }
  handleInput(data: { title: string; value: string }) {
    this.newVault[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  toggleVisibility(index: number) {
    this.showKey[index] = !this.showKey[index]; // Toggle visibility
  }
  formatDate(date: string) {
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleString();
  }
  validateForm = () => {
    const errors: any = {};
    if (this.newVault.name === '') {
      errors.name = 'Required*';
    } else if (this.newVault.environment === '') {
      errors.environment = 'Required*';
    }
    return errors;
  };
  manageRoute(data: any) {}
  search(value: any) {}
  changeLimit(limit: any) {}
  applyFilter(data: any) {}
  refreshList() {}

  createVault = () => {
    this.newVault.environment = this.newVault.environment.toLowerCase();
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
      this.loading = true;
      this.vaultService.createVault(this.newVault).subscribe(
        (res: any) => {
          this.createModalOpen = false;
          this.loading = false;
          this.getVaults();
          this.notification.success('Success', 'Vault Created', {
            nzClass: 'notification',
          });
          this.newVault = {
            name: '',
            environment: '',
          };
        },
        (error) => {
          this.loading = false;
          this.notification.error('Error', 'Something went wrong', {
            nzClass: 'notification',
          });
        }
      );
    }
  };

  getVaults() {
    this.fetchingData = true;
    this.vaultService.getVaults().subscribe({
      next: (res: any) => {
        this.fetchingData = false;
        console.log(res);
        this.vaults = res.data;
        if (this.vaults.length == 0) this.emptyState = true;
        this.limit = res?.pagination?.limit;
        this.page = res?.pagination?.page;
        this.totalVaults = res?.pagination?.total;
        this.pages = res?.pagination?.pages;
        this.tableHeader = [
          { name: 'Vault Name', ratio: { width: '33%', minWidth: '204px' } },
          {
            name: 'Vault Environment',
            ratio: { width: '33%', minWidth: '83px' },
          },
          { name: 'Vault Key', ratio: { width: '33%', minWidth: '83px' } },
        ];
        this.tableData = this.vaults.map((vault: any, n: number) => {
          return [
            {
              name: {
                title: vault.name,
                label: this.generalService.formatDate(vault.createdAt),
              },
              ratio: { width: '33%', minWidth: '180px' },
              id: vault._id,
            },
            {
              name: {
                title: `<span class="capitalize font-[500]">${vault.environment}</span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: vault._id,
            },
            {
              name: {
                title: `<span>${vault.vaultKey}&nbsp;</span><span></span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: vault._id,
            },
          ];
        });
      },
      error: (err) => {
        this.fetchingData = false;
        this.notification.error('Error', 'Failed to fetch vault data', {
          nzClass: 'notification',
        });
        this.emptyState = true;
      },
    });
  }
  deleteVault = () => {
    this.loading = true;
    this.vaultService.deleteVault(this.deleteId).subscribe({
      next: (res: any) => {
        this.deleteModalOpen = false;
        console.log(res);
        this.loading = false;
        this.notification.success('Vault Deleted', '', {
          nzClass: 'notification',
        });
        this.getVaults();
      },
      error: (err: any) => {
        console.log(err);
        this.deleteModalOpen = false;
        this.loading = false;
      },
    });
  };
}
